import type { OperatorData } from './MetricRepository';

export default {
  toPacket: ({ offset, offsetMetrics }: OperatorData<'avgHeartRate'>) =>
    offsetMetrics.filter((_: number, i: number) => i <= offset).pop(),

  toValue: ({ offsetMetrics }: OperatorData<'avgHeartRate'>) =>
    offsetMetrics.reduce((acc: number, v: number) => acc + v, 0),
};
